"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenamePropertiesMode = void 0;
const Utils_1 = require("../../../utils/Utils");
exports.RenamePropertiesMode = Utils_1.Utils.makeEnum({
    Safe: 'safe',
    Unsafe: 'unsafe'
});
